import { ArrowRight, Search } from "lucide-react";
import type { ChainId } from "../../server/types";
import { CHAIN_SHORT } from "../lib/format";

export type ChainChoice = ChainId | "auto";

interface SearchBoxProps {
  query: string;
  chain: ChainChoice;
  busy?: boolean;
  compact?: boolean;
  onQueryChange: (value: string) => void;
  onChainChange: (value: ChainChoice) => void;
  onSubmit: () => void;
}

const choices: ChainChoice[] = ["auto", "solana", "ethereum", "bsc", "robinhood"];

export function SearchBox({
  query,
  chain,
  busy,
  compact,
  onQueryChange,
  onChainChange,
  onSubmit,
}: SearchBoxProps) {
  return (
    <form
      className={`search-shell ${compact ? "search-shell--compact" : ""}`}
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <div className="chain-picker" role="group" aria-label="Choose blockchain">
        {choices.map((choice) => (
          <button
            key={choice}
            type="button"
            className={chain === choice ? "active" : ""}
            onClick={() => onChainChange(choice)}
          >
            {choice === "auto" ? "Auto" : CHAIN_SHORT[choice]}
          </button>
        ))}
      </div>
      <div className="search-input-wrap">
        <Search size={compact ? 17 : 21} strokeWidth={2.2} aria-hidden="true" />
        <input
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Token name, symbol, contract or mint address"
          aria-label="Token name, symbol, contract or mint address"
          autoComplete="off"
          spellCheck={false}
        />
        <button className="search-submit" type="submit" disabled={busy || !query.trim()}>
          {compact ? <ArrowRight size={18} /> : <><span>Map it</span><ArrowRight size={18} /></>}
        </button>
      </div>
    </form>
  );
}
